<template>
<div>

<ContentOverlay></ContentOverlay>


<div class="content_card" v-if="!$store.state.ui.contentframeloading">
<ContentHeader :title="$store.state.languages.lang_phrases.projeler"  :show_button="false" ></ContentHeader>


<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>



<div class="content_card_content" v-if="!loading">


<template v-if="!data.length">
<div class="flex align-items-center justify-content-center mb-8 mt-8">
<h3 class="text-primary font-medium">{{$store.state.languages.lang_phrases.henuz_hic_kayit_olusturulmamis}}</h3>

</div>
</template>

<template v-else>


<ContentTableExtended :data="data" :columns="columns" routename="SupplierBrandProjectAllPeriods"  @dataDeleted="getData" identifier_row="id" identifier_row_name="project_id"></ContentTableExtended>

</template>


</div>





</div>







</div>
</template>
<script>
export default {

  name: 'SupplierBrandProjects',

   data () {
     return {
      data:[],
      loading:true,
      columns:[  
      {
        type:"text",
        field:"project_name",        
        with_route:true,
        header:"proje",
        hide_on_mobile:false,
      },
      {
        type:"text",
        field:"last_active_period_name", 
        header:"son_aktif_periyod",
        hide_on_mobile:false,
      },
      {
        type:"pill",
        field:"last_active_period_status",
        header:"son_aktif_periyod_durumu",
        options:[
          {
            name:"created",
            color:"#352f8d",
            text:"olusturuldu",
          },
          {
            name:"viewed",
            color:"#7e2f8d",
            text:"goruntulendi",
          },
          {
            name:"started",
            color:"#dd4b39",
            text:"baslandi",
          },
          {
            name:"finished",
            color:"#4dc247",
            text:"tamamlandi0",
          },
          {
            name:"under_review",
            color:"#ff6600",
            text:"degerlendirmede",
          },
          {
            name:"canceled",
            color:"#a82400",
            text:"iptal_edildi",
          },
          {
            name:"correction_requested",
            color:"#3b82f6",
            text:"duzeltme_talebi_incelemede",
          },
        ],
      },
      {
        type:"text",
        field:"activeflow_name",
        header:"aktif_akis",
        hide_on_mobile:false,
      },
      {
        type:"pill",
        field:"flowtype",
        header:"tur",
        options:[
          {
            name:"self_evaluation",
            color:"#ff6600",
            text:"self_evaluation",
          },
          {
            name:"education",
            color:"#3b82f6",
            text:"egitim",
          },
          {
            name:"verification",
            color:"#7e2f8d",
            text:"verification",
          },
          {
            name:"audit",
            color:"#352f8d",
            text:"audit",
          },
        ],
      }, 
      
      {
        type:"boolean",
        field:"verified",
        header:"verified",
        hide_on_mobile:false,
      },
      ]
    }
  },
   mounted()
  {
  	
  	this.getData()
  },
  methods:{
    orderProjects(a, b )
    {
       if ( a.project.queue < b.project.queue ){
        return -1;
      }
      if ( a.project.queue > b.project.queue ){
        return 1;
      }
      return 0;

    },
  	async getData()
  	{
      this.loading = await true
      //await console.log(this.$store.state.auth.user)
  		let data = await this.generalApiGetWithoutLoader("get_audits_for_suuplier/"+this.$route.params.supplier_uuid) 
      console.log("data")
      console.log(data)
      //data  = await data.sort(this.orderProjects)

      for(let item of data)
      {

        item.project_name = item
        item.last_active_period_name = item.lastprojectsupplier.projectperiod
        item.last_active_period_status = item.lastprojectsupplier.status
        if(item.lastprojectsupplier && item.lastprojectsupplier.activeflow)
        {
          item.activeflow_name = item.lastprojectsupplier.activeflow
          item.flowtype = item.lastprojectsupplier.activeflow.type
        }
        
        item.verified = item.lastprojectsupplier.verified
        item.uuid = item.lastprojectsupplier.uuid


      }

      this.data = await data
      this.loading = await false


      /*
      data  = await data.sort(this.orderProjects)
      await console.log(data);
      for(let item of data)
      {
        item.project_name = item.project.name
        item.project_period_name = item.projectperiod.name
        let brand_name = await item.project.brand.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
        let project_name = await item.project.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
        let activeflow_name = await item.activeflow.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
        if( item.project.brand.translations.length)
        {
            item.brand_name = await brand_name.translation
        }
        else
        {
          item.brand_name = await item.project.brand.name
        }

        if(item.project.translations.length)
        {
          let project_name_translation = await item.project.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
          item.project_name = await item.project.translations
        }
        else
        {
          console.log("no p tra")
          item.project_name = await [
            {
              language_id:3,
              translation:item.project.name
            },
            {
              language_id:15,
              translation:item.project.name
            }
          ]
          //this.columns[0].multilingual = await false
        }

       
        if(item.activeflow.translations.length)
        {
          item.activeflow_name = await item.activeflow.translations
        }
        else
        {
          console.log("no ac tra")
          item.activeflow_name = await item.activeflow.name
          this.columns[3].multilingual = await false
        }

        
        
        
        if( item.activeflow.suppliers.length)
        {
          item.activeflowstatus = await item.status
        }
        else
        {
          item.activeflowstatus = await 0
        }
        
        item.supplier_name = await item.supplier.name
        item.uuid = await item.uuid
      }
      this.data = await data

      
      this.loading = await false
      await console.log(this.data);
      */
  	},
  	
  }
};
</script>

<style lang="css" scoped>
</style>